//@flow
export const CREATE_REQUESTED = "goals/CREATE_REQUESTED";
export const CREATE_COMPLETED = "goals/CREATE_COMPLETED";
export const CREATE_FAILED = "goals/CREATE_FAILED";

export const UPDATE_REQUESTED = "goals/UPDATE_REQUESTED";
export const UPDATE_COMPLETED = "goals/UPDATE_COMPLETED";
export const UPDATE_FAILED = "goals/UPDATE_FAILED";

export const MOVE_REQUESTED = "goals/MOVE_REQUESTED";
export const MOVE_COMPLETED = "goals/MOVE_COMPLETED";
export const MOVE_FAILED = "goals/MOVE_FAILED";

export const DELETE_REQUESTED = "goals/DELETE_REQUESTED";
export const DELETE_COMPLETED = "goals/DELETE_COMPLETED";
export const DELETE_FAILED = "goals/DELETE_FAILED";

export const FETCH_LIST_REQUESTED = "goals/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "goals/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "goals/FETCH_LIST_FAILED";

export const FETCH_DETAILS_REQUESTED = "goals/FETCH_DETAILS_REQUESTED";
export const FETCH_DETAILS_COMPLETED = "goals/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "goals/FETCH_DETAILS_FAILED";

export const RESET_LIST = "goals/RESET_LIST";
export const SELECT = "goals/SELECT";
export const UNSELECT = "goals/UNSELECT";
